import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "box task" }
const _hoisted_2 = { class: "columns" }
const _hoisted_3 = { class: "column is-7 is-flex is-align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa-sharp fa-solid fa-thumbtack",
  style: {"color":"#52f28a"}
}, null, -1)
const _hoisted_5 = { class: "column is-flex is-align-items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa-sharp fa-solid fa-stopwatch",
  style: {"color":"#52f28a"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StopWacth = _resolveComponent("StopWacth")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("p", null, _toDisplayString(_ctx.completedTask.description), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_StopWacth, {
          timeSeconds: _ctx.completedTask.duration
        }, null, 8, ["timeSeconds"])
      ])
    ])
  ]))
}